<template>
  <div>


    <div class="text-center" style="padding: 8px;">
      <em class="info_outline" style="width: 50px;"></em>
    </div>

    <div  style="margin-left: 20px;">
      <div class="text-center" >
        <div v-if="idEtapa === null">
          <span style="font-size: 12px; color: rgb(234,57,78) ; font-weight: 500"
          >El pti se inactivará porque su proceso ya no esta vigente.
            </span>
          <h5 style="font-size: 12px; color: rgb(234,57,78) ; font-weight: 500"
          > Tendrás que hacer uno nuevo.
            </h5>
        </div>
        <div v-if="totalTratamientosActivos === 0 && idEtapa !== null">
           <span  style="font-size: 12px;  ; font-weight: 500"
              >Hemos retirado los siguientes tratamientos porque se encuentran inactivos.
            </span>
            <br/>
            <span v-if="tratamientosDePti" style="font-size: 12px; color: rgb(234,57,78) ; font-weight: 500"
              >El pti se inactivará porque no tiene tratamientos Activos.
            </span>
        </div>
        <div v-else-if="idEtapa !== null">
          <span v-if="dineroDistribuido > 0 " style="font-size: 12px;  ; font-weight: 500"
              >Hemos retirado los siguientes tratamientos porque se encuentran inactivos.
            <br/>
            <span v-if="tratamientosDePti" style="font-size: 12px; color: rgb(234,57,78) ; font-weight: 500"
              >Como tu PTI tiene un pago deberás de regresar a la negociación para ingresarlo de nuevo.
            </span>
          </span>

          <span v-else style="font-size: 12px;  font-weight: 500"
          >Hemos retirado los siguientes tratamientos porque se encuentran inactivos
          </span>
        </div>


      </div>
        <div v-if="idEtapa !== null">
          <b-row
              style=" font-size: 12px; font-weight: bold; color: #ffffff !important; background-color: #17A2B8 !important;width: 90%; margin-left: 12px">
            <b-col cols="9">Tratamiento</b-col>
            <b-col class="text-center" cols="2" >Od</b-col>
          </b-row>

          <div  :style='tratamientosInactivos.length > 5
                      ? " overflow-y: scroll; max-height: 160px; width:98%; font-size: 11px"
                      : " max-height: 160px; width:89%; font-size: 11px; margin-left:12px"'>
          <b-table-simple hover>
          <b-tbody>
            <b-tr v-for="(op, index) in tratamientosInactivos"
                  :key="index+'-'+op.idTratamiento"
            >
              <b-td style="font-size: 11px">{{op.nombreTratamiento}}</b-td>
              <b-td style="font-size: 11px">{{op.numeroDiente}}</b-td>
            </b-tr>
          </b-tbody>
          </b-table-simple>
          </div>



        </div>
    </div>

    <br/>
    <div class="text-center">
      <b-button  v-if="idEtapa === null" variant="info" pill @click="inactivarPti()">
        <span v-if="!loader"> Continuar  </span>
        <b-spinner v-else small />
      </b-button>
      <b-button v-else variant="info" pill @click='totalTratamientosActivos === 0 ? inactivarPti() : cerrarModal()'>
        <span v-if="!loader"> Continuar  </span>
        <b-spinner v-else small />
      </b-button>
    </div>


  </div>
</template>
<script >
export default {
  name: "validadorTratamientosCaja",
  props: {
    tratamientosInactivos: Array,
    dineroDistribuido: Number,
    idSolicitud: Number,
    idEtapa: Number,
    totalTratamientosActivos: Number,
    idPti: Number,
    tratamientosDePti: Boolean,
  },
  data: () => ({
    loader: false,
  }),
  methods:{
    inactivarPti(){
      this.loader = true
      if (this.idEtapa === null){
        this.$http
            .delete(this.$api + "pti/cancelar/pti?idPti=" + this.idPti + "&motivo=" + 28 )
            .then((respuesta) => {
              if (respuesta.data.data){
                this.$router.push('/dashboard');
              }
            }).catch((err) => {
          console.info(err.message);
          this.loader = false;
        })
      }else if (this.tratamientosDePti){

        /*Validamos si lo que se encuentra en caja es de tipo Edición Pti*/
        if (this.idEtapa === 100){
          const param = {
            idSolicitud: this.idSolicitud,
            idPti: this.idPti
          }
          console.log(Array.from([param]), "params")

          this.$http.post(this.$api + 'edicion/cancelar/ediciones',Array.from([param])).then(respuesta => {
            if (respuesta.data.data) {
              this.loader = false;
              this.$router.push('/dashboard');
            }
          }).catch(error => {
            console.error(error);
            this.loader = false;
          })
        }else {
          this.$http
              .delete(this.$api + "pti/cancelar/pti?idPti=" + this.idPti + "&motivo=" + 28 )
              .then((respuesta) => {
                if (respuesta.data.data){
                  this.$router.push('/dashboard');
                }
              }).catch((err) => {
            console.info(err.message);
            this.loader = false;
          })
        }

      }else {
        this.$router.push('/dashboard');
      }


    },
    cerrarModal(){
      this.loader = true
      if (this.tratamientosDePti){
        const params = {
          idSolicitud: this.idSolicitud,
          montoPagadoPti: this.dineroDistribuido,
          tratamientosInactivos: this.tratamientosInactivos
        }

        this.$http.post(this.$api + "caja/regresionTratamientosInactivos", params, this.guardar)
            .then((resp) => {
              if (resp.data.data) {
                this.loader = false;


                if (this.dineroDistribuido > 0){
                  this.$router.push('/dashboard');
                }else
                if (this.dineroDistribuido === 0){
                  this.$emit("cerrarModalTratsActivos");
                }
              }
            }).catch((error) => {
          this.loader = false
          console.log(error.message)
        })
      } else {
        this.$emit("cerrarModalTratsActivos");
        //this.$router.push('/dashboard');
      }



    }
  }
}


</script>

<style scoped>

</style>